import './ProductLink.scss';

import { registryComponent } from '@boost-sd/components-registry/registry';
import { appendClassNames, createClsNameMap } from '@utils';
import type { PropsWithChildren } from 'react';

export const clsNameMap = createClsNameMap()('product-link');

export type ProductLinkProps = PropsWithChildren<{
  href: string;
  disabled?: boolean;
  className?: string;
}>;

const ProductLink = ({ href, children, disabled, className }: ProductLinkProps) => {
  if (disabled) return <>{children}</>;

  return (
    <a className={appendClassNames(clsNameMap.root(), className)} href={href}>
      {children}
    </a>
  );
};

export default registryComponent('ProductLink', ProductLink);
